import { render, staticRenderFns } from "./aluesuojaus.vue?vue&type=template&id=55768e08&scoped=true&"
import script from "./aluesuojaus.vue?vue&type=script&lang=js&"
export * from "./aluesuojaus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55768e08",
  null
  
)

export default component.exports